import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Button from '@cld/button';
import Icon from '@cld/icon';
import { usePhone } from '@cld/style-utils';
import theme from '@cld/theme-helper';
import { HeaderHeight } from './Header';

const Columns = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${theme`color.${'color'}`};
`;

export const SideButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${theme`spacing.lg`};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  &,
  * {
    pointer-events: ${({ isVisible }) => (isVisible ? 'all' : 'none')};
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${(props) => (props.isPhone ? HeaderHeight.phone : HeaderHeight.desktop)}px);
`;

export const Navigable = ({ canNavigateToNext, canNavigateToPrevious, children, onNext, onPrevious, color }) => {
  const isPhone = usePhone();

  return (
    <Columns color={color}>
      <SideButton isVisible={canNavigateToPrevious} data-test="collection-share-navigable-previous-button">
        <Button onClick={onPrevious} shape="pill" variant="secondary">
          <Icon name="keyboardArrowLeft" />
        </Button>
      </SideButton>

      <Content isPhone={isPhone}>{children}</Content>

      <SideButton isVisible={canNavigateToNext} data-test="collection-share-navigable-next-button">
        <Button onClick={onNext} shape="pill" variant="secondary">
          <Icon name="keyboardArrowRight" />
        </Button>
      </SideButton>
    </Columns>
  );
};

Navigable.propTypes = {
  canNavigateToNext: PropTypes.bool.isRequired,
  canNavigateToPrevious: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  color: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
};
